import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-navigation-item',
  templateUrl: './navigation-item.component.html',
  styleUrls: ['./navigation-item.component.scss']
})
export class NavigationItemComponent implements OnInit {

  @Input() disabled: boolean = false;
  @Input() details: boolean = true;
  @Input() color: string = 'grey';
  @Input() link: string = null;
  @Input() title: string = 'icon title';
  @Input() icon: string = 'fab fa-buffer fa-lg';
  @Output() click = new EventEmitter();


  constructor() { }

  ngOnInit(): void {
  }

  onClick() {
    this.click.emit();
  }

}
